var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvIcn1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.051,
    height: 74.625,
    viewBox: "0 0 74.051 74.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "env-icn1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2274",
    "data-name": "Groupe 2274",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 74.051,
    height: 74.625,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2653",
    "data-name": "Groupe 2653",
    transform: "translate(13.662 13.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2979",
    "data-name": "Trac\\xE9 2979",
    d: "M721.479,232.635a1.66,1.66,0,0,1-1.042-1.772,11.317,11.317,0,0,1,.549-4.174,8.771,8.771,0,0,1,7.661-5.705,5.15,5.15,0,0,1-3.594-2.029,5.02,5.02,0,0,1-.871-3.984,4.963,4.963,0,0,1,5.136-4.133,5.09,5.09,0,0,1,4.857,4.433c.325,2.814-1.238,4.848-4.445,5.743A8.648,8.648,0,0,1,735.7,224a8.394,8.394,0,0,1,2.122,5.355c.018.5-.021,1.006.018,1.5a1.593,1.593,0,0,1-1.034,1.772Z",
    transform: "translate(-705.782 -185.908)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2980",
    "data-name": "Trac\\xE9 2980",
    d: "M869.771,232.618a12.426,12.426,0,0,0-2.006-9.707A8.658,8.658,0,0,1,872.612,221a11.26,11.26,0,0,1-1.622-.552,5.534,5.534,0,0,1-1.433-1.022,4.826,4.826,0,0,1-.949-1.427,5.382,5.382,0,0,1-.422-1.71,5.7,5.7,0,0,1,.153-1.758,4.988,4.988,0,0,1,5.2-3.706,5.128,5.128,0,0,1,4.72,4.491A5.19,5.19,0,0,1,873.773,221a8.683,8.683,0,0,1,4.887,1.921,8.567,8.567,0,0,1,3.167,5.616,1.5,1.5,0,0,0,.081.253v2.829a2.112,2.112,0,0,1-1,1Z",
    transform: "translate(-835.183 -185.892)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2981",
    "data-name": "Trac\\xE9 2981",
    d: "M600,228.791c.134-.589.226-1.192.41-1.766a8.813,8.813,0,0,1,7.553-5.991c.069-.006.137-.015.253-.029-3.307-.917-4.869-2.877-4.548-5.657a5,5,0,0,1,4.947-4.525,5.123,5.123,0,0,1,5.069,4.087,5,5,0,0,1-.878,3.976,5.242,5.242,0,0,1-3.453,2.1,8.557,8.557,0,0,1,4.787,1.932,12.409,12.409,0,0,0-2,9.707H601a2.1,2.1,0,0,1-1-1Z",
    transform: "translate(-600 -185.898)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2982",
    "data-name": "Trac\\xE9 2982",
    d: "M740.64,6a16.519,16.519,0,0,1,2.726.946,7.224,7.224,0,0,1,1.909,11.017,4.071,4.071,0,0,0-1.166,2.576h-8.586a4.707,4.707,0,0,0-1.42-2.895A7.246,7.246,0,0,1,738.744,6.08,1.626,1.626,0,0,0,739,6Z",
    transform: "translate(-716.456 -6)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2983",
    "data-name": "Trac\\xE9 2983",
    d: "M868.265,6c.517.234,1,.543,1,1.165a1.819,1.819,0,0,1-.314,1.087,14.433,14.433,0,0,1-1.6,1.62,1.356,1.356,0,0,1-1.914-1.91c.521-.572,1.082-1.109,1.642-1.643A2.7,2.7,0,0,1,867.626,6Z",
    transform: "translate(-832.855 -6)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2984",
    "data-name": "Trac\\xE9 2984",
    d: "M686.033,6c.757.688,1.558,1.335,2.255,2.08a1.282,1.282,0,0,1-.2,1.769,1.328,1.328,0,0,1-1.788.022c-.561-.511-1.1-1.047-1.611-1.609a1.346,1.346,0,0,1,.428-2.119L685.394,6Z",
    transform: "translate(-674.077 -6)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2985",
    "data-name": "Trac\\xE9 2985",
    d: "M600,381.75a2.1,2.1,0,0,0,1,1h-1Z",
    transform: "translate(-600 -336.028)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2986",
    "data-name": "Trac\\xE9 2986",
    d: "M975.75,382.754a2.112,2.112,0,0,0,1-1v1Z",
    transform: "translate(-930.028 -336.028)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2987",
    "data-name": "Trac\\xE9 2987",
    d: "M756.643,148.4h8.6a4.3,4.3,0,1,1-8.6,0Z",
    transform: "translate(-737.582 -131.071)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2988",
    "data-name": "Trac\\xE9 2988",
    d: "M869.3,105.1a1.4,1.4,0,0,1-.766,1.367,1.252,1.252,0,0,1-1.451-.163,21.11,21.11,0,0,1-1.674-1.674,1.354,1.354,0,0,1,1.925-1.89,20.645,20.645,0,0,1,1.637,1.647A2.313,2.313,0,0,1,869.3,105.1Z",
    transform: "translate(-832.84 -90.686)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2989",
    "data-name": "Trac\\xE9 2989",
    d: "M688.6,103.966a3.2,3.2,0,0,1-.408.754c-.449.514-.946.987-1.442,1.457a1.366,1.366,0,1,1-1.932-1.93c.482-.506.974-1,1.485-1.479a1.306,1.306,0,0,1,1.524-.23A1.412,1.412,0,0,1,688.6,103.966Z",
    transform: "translate(-674.134 -90.661)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2990",
    "data-name": "Trac\\xE9 2990",
    d: "M664.411,62.971c-.38,0-.762.024-1.139-.005a1.284,1.284,0,0,1-1.21-1.254,1.229,1.229,0,0,1,1.076-1.4,15.519,15.519,0,0,1,2.634,0,1.227,1.227,0,0,1,1.06,1.373,1.29,1.29,0,0,1-1.191,1.275c-.407.034-.82.006-1.23.006Z",
    transform: "translate(-654.507 -53.654)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2991",
    "data-name": "Trac\\xE9 2991",
    d: "M885.017,62.807c-.334,0-.669.011-1,0a1.346,1.346,0,0,1-1.361-1.311,1.333,1.333,0,0,1,1.264-1.406,19.92,19.92,0,0,1,2.233,0,1.3,1.3,0,0,1,1.281,1.422,1.314,1.314,0,0,1-1.366,1.295C885.717,62.818,885.367,62.807,885.017,62.807Z",
    transform: "translate(-848.259 -53.479)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvIcn1);
export default __webpack_public_path__ + "static/media/env-icn1.d05b5c4587b11930da0c7919312b4c58.svg";
export { ForwardRef as ReactComponent };